/* eslint-disable operator-linebreak */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import ReactModal from 'react-modal';

import { ISecurityQuestionAnswer } from 'src/interfaces';
import { SecurityQuestionAnswerForm } from './questions-form';

export const SecurityQuestionsModal: React.FC<{
  isOpen: boolean;
  questions: ISecurityQuestionAnswer[];
  onAnswer: Function;
}> = ({ isOpen, questions, onAnswer }) => {
  const [securityQuestionAnswer, setSecurityQuestionAnswer] = useState<ISecurityQuestionAnswer[]>(questions);

  const [modalIsOpen, setIsOpen] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setSecurityQuestionAnswer(questions);
  }, [questions]);

  const handleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  return (
    <ReactModal
      isOpen={modalIsOpen}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: 'max-content',
          maxWidth: '600px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
    >
      <SecurityQuestionAnswerForm onAnswer={onAnswer} handleModal={handleModal} questions={securityQuestionAnswer} />
    </ReactModal>
  );
};
